/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-02 14:58:24
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noSupos1: '请先到',
  noSupos2: '上传要安装的文件',
  noSupos3: '菜单',
  installSupos: '可视化安装',
  package: '安装包管理',
});
